import * as yup from 'yup';

export const OtpformSchema = yup.object({
  phone: yup
    .string()
    .required()
    .matches(/^(?:|01)?(?:\d{9}|)$/, 'Phone no. not valid'),
});
